import { updateMFAPreference, verifyTOTPSetup } from 'aws-amplify/auth';
import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { toast } from 'react-toastify';

import { OtpFormInput } from '@/shared/components/ui/form/components/form-input/variant/otp-form-input/otp-form-input';
import { Submit } from '@/shared/components/ui/form/components/submit/submit';
import { Form } from '@/shared/components/ui/form/form';
import { FormContainer } from '@/shared/components/ui/form/form.styled';
import { TSubmittedData } from '@/shared/components/ui/form/form.types';
import { TEnableMfaInputSchema } from '@/shared/features/rbac/components/enable-mfa/enable-mfa.types';
import { enableMfaInputSchema } from '@/shared/features/rbac/components/enable-mfa/enable-mfa.validation';
import { TEnableMfaFormProps } from '@/shared/features/rbac/components/enable-mfa-form/enable-mfa-form.types';
import { logout } from '@/shared/redux/api/auth/auth-api';
import { useAppDispatch } from '@/shared/redux/hooks/hooks';

export const EnableMfaForm: React.FC<TEnableMfaFormProps> = ({ onClose }) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const handleSubmit = async (
    data: TSubmittedData<TEnableMfaInputSchema>,
    methods: UseFormReturn<TEnableMfaInputSchema>,
  ) => {
    const { setError } = methods;

    try {
      await verifyTOTPSetup(data.data);
      await updateMFAPreference({ totp: 'PREFERRED' });
      await dispatch(logout());
      toast.success(t('rbac:enable_mfa_success'));
      navigate(0);
    } catch (error) {
      const errorMessage = (error as Error).message;
      if (errorMessage.includes('mismatch')) {
        setError('code', {
          type: 'manual',
          message: t('error:invalid_token'),
        });
      }
    }
  };

  return (
    <Form<TEnableMfaInputSchema>
      onSubmit={handleSubmit}
      schema={enableMfaInputSchema}
    >
      {() => (
        <FormContainer justifyContent="space-between">
          <OtpFormInput<TEnableMfaInputSchema> name="code" />
          <Submit onClose={onClose} submitButtonLabel={t('common:confirm')} />
        </FormContainer>
      )}
    </Form>
  );
};
